export default __webpack_public_path__ + "static/media/slide2.e87e2a68.jpg";